import React, { useState } from "react";
import { signUpUser, db } from "../../utils/firebase";
import { useNavigate, Link } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import toast from "react-hot-toast";

const SignUp: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSignup = async () => {
    try {
      const { user } = await signUpUser(email, password);
      await setDoc(doc(db, "users", user.uid), { email });

      toast.success("Compte créé avec succès !");

      // Ensure all Firebase state updates complete before redirect
      navigate("/", { replace: true });
    } catch (error: any) {
      if (error.code === "auth/email-already-in-use") {
        toast.error("Cet email est déjà utilisé.");
      } else if (error.code === "auth/invalid-email") {
        toast.error("L'email est invalide.");
      } else if (error.code === "auth/weak-password") {
        toast.error("Le mot de passe est trop faible.");
      } else {
        toast.error("Erreur lors de la création du compte.");
      }
      console.error("Signup Error:", error);
    }
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-50">
      <div className="bg-white p-8 shadow-lg rounded-xl w-96">
        <h2 className="text-2xl font-semibold mb-6">Inscription</h2>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border rounded-md px-3 py-2 w-full mb-4"
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="border rounded-md px-3 py-2 w-full mb-6"
        />

        <button
          onClick={handleSignup}
          className="w-full bg-black text-white py-2 rounded-md hover:bg-gray-800 transition duration-150"
        >
          S'inscrire
        </button>

        <p className="text-center mt-4 text-sm text-gray-600">
          Déjà un compte ?{" "}
          <Link className="text-blue-500 underline" to="/login">
            Se connecter
          </Link>
        </p>
      </div>
    </div>
  );
};

export default SignUp;
